module.exports = __webpack_public_path__ + "assets/img/profile-goals.78b64c60.svg";